import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export type ManagementToken<TTokenType extends keyof ManagementTokens> = {
  type: TTokenType;
  error?: string;
  token: ManagementTokens[TTokenType];
} & ManagementTokenMeta;

/** A type containing a mapping of all existing token types to their content. We don't ever want to actually store the token, just some information about the token. */
export interface ManagementTokens {
  vpp: {
    expirationDate: Date;
  };
  dep: {
    expirationDate: Date;
  };
  push: {
    expirationDate: Date;
  };
  vendor: {
    expirationDate: Date;
  };
}

export interface ManagementTokenMeta {
  server: string;
  endpoint: string;
}

export const managementTokensMeta: { [i in keyof ManagementTokens]: ManagementTokenMeta } = {
  vpp: {
    server: 'mdm',
    endpoint: 'tokens/vpp',
  },
  dep: {
    server: 'dep',
    endpoint: 'tokens/server-token',
  },
  push: {
    server: 'mdm',
    endpoint: 'certificates/push',
  },
  vendor: {
    server: 'mdm',
    endpoint: 'certificates/vendor',
  },
};

export type ManagementState = EntityState<ManagementToken<keyof ManagementTokens>>;

export function selectExpirationDate(token: ManagementToken<keyof ManagementTokens>): Date | undefined {
  return 'expirationDate' in token.token ? token.token.expirationDate : undefined;
}

export function selectId(token: ManagementToken<keyof ManagementTokens>) {
  return token.type;
}

export const adapter: EntityAdapter<ManagementToken<keyof ManagementTokens>> = createEntityAdapter<
  ManagementToken<keyof ManagementTokens>
>({
  selectId,
});

export const initialState: ManagementState = adapter.getInitialState();
